import React, { useState, useEffect } from "react";
import { SectionTitle } from "components/items";
import { BtnIcon } from "components/btns";
import { BtnText } from "components/btns";
import makeTitle from "function/makeTitle.js";

// image
import icon_left from "image/icon/ic_arrow_left_w.svg";
import icon_right from "image/icon/ic_arrow_right_w.svg";
import img_process_01 from "image/process/process-01.png";
import img_process_02 from "image/process/process-02.png";
import img_process_03 from "image/process/process-03.png";
import img_process_04 from "image/process/process-04.png";
import img_process_05 from "image/process/process-05.png";

import download_02 from "download/service/process_01.pdf";
import download_01 from "download/service/process_02.pdf";

const sectionTitle = [
	{
		text: "BUSINESS",
		color: "defualt",
		break: false,
	},
	{
		text: "PROCESS",
		color: "main",
		break: true,
	},
];
const processList = [
	{
		id: 1,
		title: "상담",
		text:
			"만들고자 하는 아이디어를 가지고 동구밭 팩토리에 방문하여 직접 상담을 진행해보세요. 동구밭 팩토리의 전문가들이 체계적인 프로세스를 통해 고객의 브랜드에 최적화된 제품을 만들기 위해 준비하고 있습니다.",
		image: img_process_01,
	},
	{
		id: 2,
		title: "샘플제작",
		text:
			"향, 컬러, 크기, 모양 등  제품의 기본적인 사양을 선택한 후 가장 근접한 샘플을 만들기 위한 제작기간은 약 1~2주 정도 소요됩니다. (추가적인 샘플 제작이 있을 시 전체적인 제작 일정이 늘어날 수 있습니다.)",
		image: img_process_02,
	},
	{
		id: 3,
		title: "제품 확정",
		text: "샘플 작업을 통해 가장 적합한 레시피를 선택한 후 패키지와 납품 방식, 납품 일자 견적 등 구체적인 사양을 확정합니다. ",
		image: img_process_03,
	},
	{
		id: 4,
		title: "제품 생산/패키지 제작",
		text: "제품의 사양과 납품방식이 모두 확정되면, 제품의 생산이 시작됩니다. 제품 수량과 사양에 따라 다르지만, 일반적인 경우 평균 2주 정도가 소요됩니다.",
		image: img_process_04,
	},
	{
		id: 5,
		title: "납품",
		text: "정해진 납기일과 납품장소로 제품이 납품됩니다. 물량이 많아 추가 생산과 납품이 있을 경우 평균 2주 정도가 추가로 소요됩니다.",
		image: img_process_05,
	},
];

const BusinessProcess = () => {
	const [nowProcess, setNowProcess] = useState(0);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		checkWindowWidth();
		window.addEventListener("resize", checkWindowWidth);
	}, []);

	const onProcessClick = (e) => {
		setNowProcess(e.target.innerText.slice(-1) - 1);
	};

	const arrowClick = (e) => {
		e.preventDefault();
		if (e.target.classList.contains("btn-process-left") && nowProcess > 0) {
			setNowProcess(nowProcess - 1);
		} else if (e.target.classList.contains("btn-process-right") && nowProcess < 4) {
			setNowProcess(nowProcess + 1);
		}
	};

	const drawProcessWeb = () => {
		return processList.map((el) => {
			return (
				<li className={`processList step-${el.id} web`} key={el.id}>
					<div className="info-left">
						<div className="wrap-text">
							<h5>
								STEP {el.id}. <span className="color-main">{el.title}</span>
							</h5>
							<p>{el.text}</p>
						</div>
						<div className="process-bar">
							<div className={`bar-highlight bar-${el.id}`}></div>
							<ul>
								<li>step 1</li>
								<li>step 2</li>
								<li>step 3</li>
								<li>step 4</li>
								<li>step 5</li>
							</ul>
						</div>
					</div>
					<div className="wrap-img">
						<img src={el.image} alt="" />
					</div>
				</li>
			);
		});
	};

	const drawProcessMobile = () => {
		const el = processList[nowProcess];
		return (
			<li className={`processList`} key={el.id}>
				<div className="info-left">
					<div className="wrap-text">
						<h5>
							STEP {el.id}. <br /> <span className="color-main">{el.title}</span>
						</h5>
						<p>{el.text}</p>
					</div>
					<div className="process-bar">
						<div className={`bar-highlight bar-${el.id}`}></div>
						<ul onClick={onProcessClick}>
							<li>step 1</li>
							<li>step 2</li>
							<li>step 3</li>
							<li>step 4</li>
							<li>step 5</li>
						</ul>
					</div>
				</div>
				<div className="wrap-img">
					{nowProcess > 0 ? <BtnIcon className="btn-process btn-process-left" image={icon_left} name="process left" onClick={arrowClick} /> : ""}

					<img src={el.image} alt="" />
					{nowProcess < 4 ? <BtnIcon className="btn-process btn-process-right" image={icon_right} name="process right" onClick={arrowClick} /> : ""}
				</div>
			</li>
		);
	};

	const checkWindowWidth = () => {
		if (window.innerWidth < 768) {
			setIsMobile(true);
		} else {
			setIsMobile(false);
		}
	};

	return (
		<section className="BusinessProcess">
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="center" />
					<p className="section-text center">
						동구밭 팩토리가 고객의 니즈에 맞춰 제품을 생산하는 과정은 총 5단계로 나누어 집니다. 각 과정은 완성하고자하는 브랜드의 성격에 맞게 유기적으로 맞춰 진행되며, 니즈에 맞는 최상의 결과물을 만들
						수 있도록 최적화되어 있습니다. 제품 유형별 제조공정은 다를 수 있으므로 각 제품별 제조공정을 확인해주세요. 또한, 모든 공정은 제작 요건 및 추가 요청사항에 따라 제작기간이 변동 될 수 있음을
						알려드립니다.
					</p>
				</div>
			</div>
			<div className="section-contents">
				<div className="con">
					<div className="wrap-btns">
						<BtnText text="입욕제 제조공정(PDF)" className="border" download={"입욕제 제조공정"} to={download_01} />
						<BtnText text="CP/약산성 비누 제조공정(PDF)" className="border" download={"CP/약산성 비누 제조공정"} to={download_02} />
					</div>

					<ul className="wrap-process">{isMobile ? drawProcessMobile() : drawProcessWeb()}</ul>
				</div>
			</div>
		</section>
	);
};

export default BusinessProcess;
